import { Module } from 'wrapper6'

const $ = jQuery

export default class TechnicalData extends Module {
  ready (app) {
    this.onTabsClick()
  }

  onTabsClick () {
    const tabs = document.querySelectorAll('.mtt-technical-data__tab')

    if (tabs.length) {
      for (let i = 0; i < tabs.length; i++) {
        const tab = tabs[i]

        tab.addEventListener('click', () => {
          const id = tab.getAttribute('data-id')
          const widgetWrapper = this.findAncestor(tab, '.mtt-technical-data')
          const dataWrapper = tab.parentElement.nextElementSibling

          widgetWrapper.querySelector('.mtt-technical-data__tab.active').classList.remove('active')

          tab.classList.add('active')

          if (dataWrapper) {
            const data = dataWrapper.querySelector('[data-id="' + id + '"]')

            if (data) {
              if (document.querySelector('.is-sticky')) {
                $([document.documentElement, document.body]).animate({
                  scrollTop: $(data).offset().top - 180
                }, 500)
              } else {
                $([document.documentElement, document.body]).animate({
                  scrollTop: $(data).offset().top - 100
                }, 500)
              }
            }
          }
        })
      }
    }
  }

  findAncestor (el, selector) {
    let parent_container = el
    do {
      parent_container = parent_container.parentNode
    }
    while (!parent_container.matches(selector) && parent_container !== document.body)

    return parent_container
  }
}
